import { render, staticRenderFns } from "./SponserHomeEight.vue?vue&type=template&id=163c4240&"
import script from "./SponserHomeEight.vue?vue&type=script&lang=js&"
export * from "./SponserHomeEight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports